import { Page } from 'corso-admin-ui';
import McpServerSettings from './McpServerSettings';
import StoreIdentitySettings from './StoreIdentitySettings';
import WebhookSettings from './WebhookSettings';

export default function DeveloperSettingsPage() {
  return (
    <Page title="Developer">
      <div className="flex flex-col gap-4">
        <WebhookSettings />
        <StoreIdentitySettings />
        <McpServerSettings />
      </div>
    </Page>
  );
}
